var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5949 3.41247C14.5127 3.33015 14.4151 3.26485 14.3076 3.22029C14.2002 3.17573 14.085 3.1528 13.9687 3.1528C13.8523 3.1528 13.7371 3.17573 13.6297 3.22029C13.5222 3.26485 13.4246 3.33015 13.3424 3.41247L8.99991 7.74747L4.65741 3.40497C4.57517 3.32273 4.47754 3.25749 4.37008 3.21298C4.26263 3.16848 4.14746 3.14557 4.03116 3.14557C3.91485 3.14557 3.79969 3.16848 3.69224 3.21298C3.58478 3.25749 3.48715 3.32273 3.40491 3.40497C3.23882 3.57106 3.14551 3.79633 3.14551 4.03122C3.14551 4.26611 3.23882 4.49138 3.40491 4.65747L7.74741 8.99997L3.40491 13.3425C3.23882 13.5086 3.14551 13.7338 3.14551 13.9687C3.14551 14.2036 3.23882 14.4289 3.40491 14.595C3.571 14.7611 3.79627 14.8544 4.03116 14.8544C4.26605 14.8544 4.49132 14.7611 4.65741 14.595L8.99991 10.2525L13.3424 14.595C13.5085 14.7611 13.7338 14.8544 13.9687 14.8544C14.2035 14.8544 14.4288 14.7611 14.5949 14.595C14.761 14.4289 14.8543 14.2036 14.8543 13.9687C14.8543 13.7338 14.761 13.5086 14.5949 13.3425L10.2524 8.99997L14.5949 4.65747C14.7571 4.49084 14.8478 4.2675 14.8478 4.03497C14.8478 3.80244 14.7571 3.5791 14.5949 3.41247Z",
    fill: "#E6E5E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.e9c7d904f19de94b90d5583d66dfb6e4.svg";
export { ForwardRef as ReactComponent };